import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { LoyaltyCardPoolPage } from './ui/pages/LoyaltyCardPoolPage';
import { LoyaltyCustomersPage } from './ui/pages/LoyaltyCustomersPage';
import { LoyaltyProgramPage } from './ui/pages/LoyaltyProgramPage';

/**
 * Loyalty feature subtree, mounted under the authenticated `AppLayout` shell.
 * `/loyalty` redirects to the day-to-day customer operations workspace; the
 * programme administration (model + tiers + rules) lives at `/loyalty/program`,
 * and the free-card pool at `/loyalty/pool`.
 */
export const loyaltyRoutes: RouteObject = {
  path: 'loyalty',
  children: [
    { index: true, element: <Navigate to="/loyalty/customers" replace /> },
    { path: 'customers', element: <LoyaltyCustomersPage /> },
    { path: 'program', element: <LoyaltyProgramPage /> },
    { path: 'pool', element: <LoyaltyCardPoolPage /> },
    { path: '*', element: <Navigate to="/loyalty/customers" replace /> },
  ],
};
